export default __webpack_public_path__ + "static/media/aminites.06ffdac1.svg";